import { defineNuxtPlugin, useRouter } from 'nuxt/app'
import { Route } from '~/apps/pu-links/domain/Route'
import { localePath } from '~/utility/route'

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()
  nuxtApp.provide('puLocalePath', (route: Route, locale?: string) => {
    try {
      const targetLocale = locale || (nuxtApp.$i18n as any).locale
      // Pass the router as the fourth parameter for route objects
      return localePath(route, targetLocale, router, 'en-gb')
    } catch (error) {
      console.error('Error in puLocalePath:', error)
      throw error
    }
  })
})
